import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-and-shipping-companies.jpg'),
    alt: 'storage and shipping companies page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage and shipping companies page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Storage</span><span>And Shipping Companies Near Me</span>',
  description:
    'Need reliable storage and shipping? ShipAndStorage offers flexible, affordable solutions for moving, traveling, or secure item storage.',
  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-companies/hero-image.jpg',
    alt: 'Reliable Storage And Shipping Companies Near Me'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Storage & Shipping Companies' }
}

export const ourProcessSectionContent = {
  title: 'Reliable Storage And Shipping Services',
  description: 'We make UPS luggage shipping quick and easy with these 3 simple steps:',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Your Service Today' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-companies/reliable-storage-and-shipping-services.png',
    alt: 'Reliable Storage And Shipping Services'
  },

  articles: [
    {
      id: 1,
      title: 'Book Online',
      description: 'Quickly schedule your storage and shipping needs through our easy-to-use online platform.',
      image: {
        src: '/images/v2/pages/common/express-delivery-options.png',
        alt: 'Book Online'
      }
    },
    {
      id: 2,
      title: 'Secure Packing & Storage',
      description: 'Pack your items securely and store them with us for as long as you need.',
      image: {
        src: '/images/v2/pages/common/safe-handling-and-pickup.png',
        alt: 'Secure Packing & Storage'
      }
    },
    {
      id: 3,
      title: 'Ship with Confidence',
      description: "When you're ready, we’ll ship your items safely to your desired destination, worldwide.",
      image: {
        src: '/images/v2/pages/common/track-and-receive.png',
        alt: 'Ship with Confidence'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast And Secure Storage And Shipping Companies',
  description:
    'At ShipAndStorage, we understand how important it is to get your items where they need to go, quickly and securely. Our expert team ensures that all items are packed with care and shipped with trusted carriers for fast delivery. Enjoy peace of mind with our secure handling and timely shipping solutions.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-companies/fast-and-secure-storage-and-shipping-companies.jpg',
    alt: 'Fast And Secure Storage And Shipping Companies'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of UPS Luggage Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description: 'Easily store and ship your items with a single provider, saving valuable time and effort.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Affordability',
      description:
        'Take advantage of low rates that are notably cheaper than traditional storage and shipping methods.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordability'
      }
    },
    {
      id: 3,
      title: 'Global Reach',
      description:
        'Ship and securely store your items worldwide, providing flexibility and convenience anywhere you go.',
      image: {
        src: '/images/v2/pages/common/global-reach.png',
        alt: 'Global Reach'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Storage And Shipping Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'People Moving for Work or Personal Reasons',
          description: 'Easily store and ship your belongings when relocating.'
        },
        {
          id: 2,
          title: 'Students',
          description: 'Ship items to and from school without the hassle of carrying large luggage.'
        },
        {
          id: 3,
          title: 'Frequent Travelers',
          description: 'Avoid baggage fees by shipping your luggage ahead of your travels.'
        },
        {
          id: 4,
          title: 'Individuals or Businesses Needing to Ship Large Quantities',
          description: 'We provide bulk shipping solutions tailored to your needs.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-companies/who-should-choose-us-for-storage-and-shipping-services.jpg',
        alt: 'Who Should Choose Us for Storage And Shipping Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Luggage Shipping',
      description:
        'Ship your luggage directly to your destination without waiting in long airport lines. Our service is convenient, fast, and affordable.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Club Shipping',
      description:
        'Send your golf clubs securely and avoid costly baggage fees at the airport. We ensure they arrive safely at your destination.',
      image: {
        src: '/images/v2/pages/common/Golf-Club-Shipping.png',
        alt: 'Golf Club Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Moving Box Shipping',
      description:
        "Whether you're moving across town or across the country, we handle your boxes with care and deliver them securely.",
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Moving Box Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Ski and Snowboard Shipping',
      description:
        'Ship your ski or snowboard gear directly to your destination, and avoid the expensive fees and hassle of carrying it with you.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Ski and Snowboard Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage And Shipping Services?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-companies/why-choose-shipandstorage-for-storage-and-shipping-services.jpg',
    alt: 'Why Choose ShipAndStorage for Storage And Shipping Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Rates',
      description: 'Save money with our budget-friendly shipping and storage solutions.'
    },
    {
      id: 2,
      title: 'Insurance Included',
      description: 'All shipments come with built-in insurance, giving you peace of mind that your items are protected.'
    },
    {
      id: 3,
      title: 'Convenient Online Booking',
      description: 'Easily manage your storage and shipping from anywhere with our user-friendly online platform.'
    },
    {
      id: 4,
      title: 'Global Reach',
      description: "No matter where you're located, we can ship and store your items worldwide."
    },
    {
      id: 5,
      title: 'Fast Delivery',
      description: 'We provide quick and reliable delivery to over 220 destinations worldwide.'
    },
    {
      id: 6,
      title: '24/7 Support',
      description: 'Our customer support team is always available to assist you with any questions or concerns.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable Storage And Shipping Companies Available',
  description:
    'Reliable storage and shipping companies near you. Fast, secure, and affordable options for storing and shipping your personal belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-companies/reliable-storage-and-shipping-companies-available.png',
    alt: 'Reliable Storage And Shipping Companies Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we partner with leading logistics providers to deliver secure, reliable, and high-quality storage and shipping solutions. Our collaborations ensure that your belongings are treated with care and safely delivered to their destination.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a globally recognized leader in logistics, providing secure storage and efficient transportation solutions for your items.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers secure and reliable global logistics services, ensuring safe storage and transportation of your belongings throughout the year.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure storage solutions and global shipping services, ensuring your belongings are handled with care from pickup to delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
